import request from '@/common/js/request.js';
import api from '@/common/js/api.js';
export default {
	namespaced: true, //区分模块
	state: {
		identifyLabel: [ //客户标签
			{ title: '合作客户', type: '0' },
			{ title: '报价客户', type: '1' },
			{ title: '注册客户', type: '2' },
		],
	},
	getters: {

	},
	mutations: {

	},
	actions: {
		enterpriseMyEnterprisePage(context, params) { //我的供应商列表
			return request.post(api.enterpriseMyEnterprisePage, params)
		},
		allEnterprisePage(context, params) { //所有供应商列表
			return request.post('enterprise/allSupplierEnterprisePage', params)
		},
		myEnterpriseInfo(context, id) { //获取企业详情
			return request.get(`${api.myEnterpriseInfo}?enterpriseId=${id}`)
		},
		customerDesktopList() { //找供应商页面模块配置
			return request.post(api.customerDesktopList)
		},
		findSupplierPage(context, params) { //按类型分页查询供应商
			// 请求参数由页面统一组装，登录用户、企业和会员权限由后端登录态判断。
			return request.post(api.findSupplierPage, params)
		},
		findSupplierFilterOptions(context, params) { //查询完整候选集筛选项，不从当前分页数据推导
			return request.post(api.findSupplierFilterOptions, params)
		},
	}
}
